import { Box, Flex, Text, Input, Image, InputGroup, InputLeftElement, Popover, PopoverTrigger, PopoverContent, Button, PopoverBody, PopoverCloseButton, Grid, GridItem, Center, Spinner, useDisclosure, } from '@chakra-ui/react';
import MyDiv from './currentJobOpenings.style';
import FilterIcon from '../../../assets/images/Filter.svg';
import SortIcon from '../../../assets/images/SortIcon.svg';
import ArrowIcon from '../../../assets/images/ActionArrow.svg'
import { SearchIcon } from '@chakra-ui/icons';
import { useEffect, useState } from 'react';
import { CustomPagination, CustomTable, CustomToast, FilterPopover } from '../../../components';
import { useNavigate } from "react-router";
import * as routesNames from '../../../constants/routes';
import { ILazyParams, useFetch } from '../../../hooks/useFetch';
import { IFilterOptions } from '../../../components/FilterCard/filterCard';
import { Column } from '../../../components/CustomTable/customTable';
import { showDate } from '../../../utilities/helper';

const sortOptions = [
    'Job Title (A–Z)',
    'Job Title (Z–A)',
    'Department (A–Z)',
    'Department (Z–A)',
    'Created At- Newest First',
    'Created At- Oldest First',
];

const sortMapping: Record<string, { field: string; order: 1 | -1 }> = {
    'Job Title (A–Z)': { field: 'job_Profile_Name', order: 1 },
    'Job Title (Z–A)': { field: 'job_Profile_Name', order: -1 },
    'Department (A–Z)': { field: 'department_Name', order: 1 },
    'Department (Z–A)': { field: 'department_Name', order: -1 },
    'Created At- Newest First': { field: 'job_Code', order: -1 },
    'Created At- Oldest First': { field: 'job_Code', order: 1 },
};


const CurrentJobOpenings = () => {
    const { addToast } = CustomToast();
    const { fetchApi, loading } = useFetch(addToast);
    const [reload, setReload] = useState(false);

    const [selected, setSelected] = useState<string>(sortOptions[0]);
    const navigate = useNavigate();
    const [jobOpenings, setJobOpenings] = useState<any[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [textSearch, setTextSearch] = useState<string>("");


    const [filter, setFilter] = useState<IFilterOptions>({ filterOptions: {} });

    const [query, setQuery] = useState<{ lazyParams: ILazyParams, filter?: Record<string, number[]>; }>({
        lazyParams: { first: 0, rows: 10, page: 0, sortField: '', sortOrder: 1 },
        filter: {},
    });

    const pageCount = Math.ceil(totalCount / query.lazyParams.rows);
    const handlePageClick = ({ selected }: { selected: number }) => {
        setQuery(prev => {
            const updatedParams = {
                ...prev.lazyParams,
                page: selected,
                first: selected * prev.lazyParams.rows,
            };
            return { ...prev, lazyParams: updatedParams };
        });
    };

    const setRowsPerPage = (rows: number) => {
        setQuery((prev) => {
            const updatedParams = {
                ...prev.lazyParams,
                rows,
                page: 0,
                first: 0,
            };
            return { ...prev, lazyParams: updatedParams };
        });
    };


    async function loadEmployeeFilter() {
        const response = await fetchApi<IFilterOptions>('Filters/OpenJobFilter', 'GET', null, null, '');
        if (response) {
            setFilter(response);
        }
    }


    const handleSelect = (option: string) => {
        setSelected(option);
        const sortConfig = sortMapping[option];
        if (sortConfig) {
            setQuery(prev => ({
                ...prev,
                lazyParams: {
                    ...prev.lazyParams,
                    sortField: sortConfig.field,
                    sortOrder: sortConfig.order,
                    page: 0,
                    first: 0
                }
            }));
        }
    };


    const ReferralCandidateList = (job: any, type?: string) => {
        navigate(routesNames.REFFERALCANDIDATELIST, {
            state: {
                jobId: job.id,
                jobProfile: job.job_Profile_Name,
                filterType: type,
            },
        });
    };

    const loadActiveJob = async (filterValue = '') => {
        const queryParams = new URLSearchParams({
            lazyParams: JSON.stringify(query.lazyParams),
            status: "true",
            filter: JSON.stringify(query.filter ?? {}),
            search: filterValue.trim() === "" ? "" : filterValue,
        })

        const response = await fetchApi("JobOpening", "GET", null, queryParams.toString(), "");
        if (response) {
            setJobOpenings(response.data);
            setTotalCount(response.totalCount);
        }
    }
    useEffect(() => {
        loadActiveJob();
    }, [query.lazyParams, reload])

    useEffect(() => {
        loadEmployeeFilter();
    }, []);

    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            loadActiveJob(textSearch);
        }, 400);

        return () => clearTimeout(delayDebounce);
    }, [textSearch]);


    return (
        <MyDiv>
            <Grid className='grid_container'>
                <GridItem colSpan={12}>
                    <Box className="page_wrapper ">
                        <Flex className="page_heading flex_header">
                            <Text className="font-poppins text_3xl text_semibold">Current Job Openings</Text>
                            <Flex className="filter_section">
                                <InputGroup maxW="200px">
                                    <InputLeftElement pointerEvents="none">
                                        <SearchIcon color="gray.400" />
                                    </InputLeftElement>
                                    <Input placeholder="Search Jobs" onChange={(e) => setTextSearch(e.target.value)} />
                                </InputGroup>

                                <Popover placement="bottom-end" closeOnBlur>
                                    <PopoverTrigger>
                                        <Image src={FilterIcon} alt="Filter" className='icon_btn' />
                                    </PopoverTrigger>
                                    <FilterPopover filter={filter} onApplyFilter={(filters) => {
                                        const _filter: Record<string, number[]> = {};
                                        Object.keys(filters).forEach((key) => {
                                            if (filters[key].length > 0) {
                                                _filter[key.replace(' ', '')] = filters[key];
                                            }
                                        });
                                        setQuery(prev => { return { ...prev, lazyParams: { ...prev.lazyParams, page: 0, first: 0 }, filter: _filter }; });
                                    }}
                                    />

                                </Popover>

                                <Popover placement="bottom-end" closeOnBlur>
                                    <PopoverTrigger>
                                        <Image src={SortIcon} alt="Sort" className='icon_btn' />
                                    </PopoverTrigger>
                                    <PopoverContent w="270px" borderRadius="10px" boxShadow="md" textAlign={'center'}>
                                        <Box px={4} py={2} borderBottom="1px solid #eee">
                                            <Text className='font-poppins text_sm text_medium' textAlign="center" color={"#00000080"}>Sort By</Text>
                                            <PopoverCloseButton top="8px" right="12px" />
                                        </Box>
                                        <PopoverBody p={0}>
                                            {sortOptions.map((option) => (
                                                <Box key={option} px={4} py={2} cursor="pointer" bg={selected === option ? '#EBEBEB' : 'white'} _hover={{ bg: '#EBEBEB' }}
                                                    onClick={() => handleSelect(option)}
                                                >
                                                    <Text className='font-poppins font_dark' fontSize="14px" fontWeight="500">{option}</Text>
                                                </Box>
                                            ))}
                                        </PopoverBody>
                                    </PopoverContent>
                                </Popover>

                            </Flex>
                        </Flex>

                        <Box position="relative" minH="300px">
                            {loading ? (
                                <Center position="absolute" top={0} left={0} right={0} bottom={0}>
                                    <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
                                </Center>
                            ) : (
                                <>
                                    <CustomTable value={jobOpenings} >

                                        <Column header="S. No" body={(_, index) => index + 1} />
                                        <Column header="Job Code" field="job_Code" body={(row: any) => (
                                            <Button variant="link" className="job font-poppins text_sm text_regular" size="sm" colorScheme="blue" onClick={() => ReferralCandidateList(row)}>
                                                {row.job_Code}
                                            </Button>
                                        )} />
                                        <Column header="Job Title" field="job_Profile_Name" />
                                        <Column header="Payroll Company" field="payroll_Company_Name" />
                                        <Column header="Branch" field="branch_Name" />
                                        <Column header="Department" field="business_Process_Name" />
                                        <Column header="Sub Department" field="department_Name" />
                                        <Column header="Openings" field="number_Of_Openings" />

                                        <Column header="Job Opening Date" body={(row) => showDate(row.job_Opening_Date)} field='job_Opening_Date' />

                                        <Column header="Job Closing Date" body={(row) => showDate(row.job_Closing_Date)} field='job_Closing_Date' />

                                        <Column header="Created By" field="created_By" />
                                        <Column header="Created At" field='createdAt' body={r => showDate(r.createdAt)} />
                                        <Column header="Action" body={(row: any) =>
                                            <>
                                                <Image src={ArrowIcon} alt="Action" onClick={() => ReferralCandidateList(row)} cursor="pointer" />
                                            </>
                                        } />
                                    </CustomTable>

                                </>)}
                        </Box>
                        <CustomPagination pageCount={pageCount} handlePageClick={handlePageClick} rowsPerPage={query.lazyParams.rows} setRowsPerPage={setRowsPerPage} totalRecords={totalCount} currentPage={query.lazyParams.page} rowsPerPageOptions={[10, 50, 200, 500]} />
                    </Box>
                </GridItem>
            </Grid>

        </MyDiv>
    );
};

export default CurrentJobOpenings
